module.exports = __webpack_public_path__ + "media/images/article/2021_bn-1b3a4e142693dc0e888a4f33223f07d0.png";